import { Title, Image } from "../../../../src/blog/components";
import WEBPACK from "../../../../src/blog/what-have-webpack-done/webpack.png";
import * as React from 'react';
export default {
  Title,
  Image,
  WEBPACK,
  React
};